import { SanitizedHtml } from '../components/SanitizedHtml';

export default SanitizedHtml;
